import { Typography } from "@mui/material";

const MainTitle=({title})=>{
return(
    <Typography fontSize="20px" fontWeight="600" textAlign="center" textTransform="uppercase"  sx={{ borderBottom: '2px solid #ED1E24', margin: 'auto', width: 'fit-content',transition: 'all 0.3s' }}>
                   {title}
    </Typography>
)
}
export default MainTitle;